export var BaseDict = {
    TodayEvents: "Today",
    TomorrowEvents: "Tomorrow",
    AntepostEvents: "Future"
};
//# sourceMappingURL=dict.js.map